import Box from '@mui/material/Box';
import { observer } from 'mobx-react';
import DIcon from "./image/Icon256.png";
import MiningImage from "./image/MiningIcon.png";
import PulsImage from "./image/PlusIcon.png";
import TimeImage from "./image/Time.png";
import LinearProgress from '@mui/material/LinearProgress';
import EditImage from "./image/Edit.png";
import WalletImage from './image/Wallet.png';
import { useMediaQuery } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Grid } from '@mui/material';
import { useStore } from "../../state/MobxContext";
import { useEffect } from "react";




function MiningBar() {
    const { loginStore } = useStore();
    const { CoinStore } = useStore();
    const { MiningStore } = useStore();




    const isMobile = useMediaQuery("(max-width: 600px)");
    const isMD = useMediaQuery("(max-width: 960px)");

    // const remain_count = MiningStore.UserMiningListState.remain_count;


    const CountTypographyMobile = withStyles({
        root: isMobile ?
            {
                fontSize: '0.8rem',
            }
            :
            {
                fontSize: '0.9rem',
            }
    })(Typography);

    const StandCount = CoinStore?.StandData;


    const MiningUserMiningListData = MiningStore?.UserMiningListData;

    let RemainSecondMin = MiningStore?.RemainSecondMin;
    let RemainSecondSec = MiningStore?.RemainSecondSec;
    // let RemainSecond = MiningStore.RemainSecond;


    useEffect(() => {//채굴 타이머
        // console.log("MiningTimer");
        const countdown = setInterval(() => {
            if (MiningStore?.RemainSecondSec > 0) {
                // console.log("MiningTimerRemainSecondSec");
                MiningStore.setRemainSecondSec(MiningStore.RemainSecondSec - 1);
            }
            if (MiningStore?.RemainSecondSec === 0) {
                MiningStore.getUserMiningList("1Min");
                if (MiningStore?.RemainSecondMin === 0) {
                    if (MiningStore?.RemainSecondHour === 0) {
                        clearInterval(countdown);
                    }
                    else {
                        MiningStore.setRemainSecondHour(parseInt(MiningStore?.RemainSecondHour) - 1);
                        MiningStore.setRemainSecondMin(59);
                    }
                }
                else {
                    if (parseInt(MiningStore?.RemainSecondMin) === 59) {
                        MiningStore.setRemainSecondSec(59);
                    }
                    MiningStore.setRemainSecondMin(parseInt(MiningStore?.RemainSecondMin) - 1);
                    MiningStore.setRemainSecondSec(59);
                }
            }
        }, 1000);
        return () => clearInterval(countdown);
        // eslint-disable-next-line
    }, [RemainSecondMin, RemainSecondSec]);


    useEffect(() => {//채굴바 값
        const CountUp = setInterval(() => {
            if (MiningUserMiningListData.remain_count > 0) {
                MiningStore.setTimeBar(1);
            }
            if (MiningStore?.RemainSecondSec === 0) {
                if (MiningStore?.RemainSecondMin === 0) {
                    clearInterval(CountUp);
                }
            }
        }, 1800);
        // if(parseInt(MiningUserMiningListData.remain_second) == 0) {
        //     return () =>setTimeout(() => { clearInterval(CountUp); }, 1000);
        // }
        return () => clearInterval(CountUp);
        // eslint-disable-next-line
    }, [MiningUserMiningListData?.remain_count]);




    let Guide_clover_allPage_06 = loginStore?.Guide_clover_allPage_06; //회



    return (
        <div>
            <Grid container spacing={1} maxWidth='xl' minWidth='full' marginTop='0px' marginBottom='15px' >
                <Grid item xs={12} sm={12} md={4} >
                    <Box bgcolor="black" color='info.contrastText' borderRadius={2} p={2} paddingLeft={1} onClick={(e) => { loginStore.setDialogOpen("Wallet") }} >
                        <Grid container justifyContent='flex-start' alignItems='center'>
                            <img style={{ width: '30px' }} src={WalletImage} alt="WalletImage" />
                            <img style={{ width: '25px', marginRight: '2px' }} src={DIcon} alt="DIcon" />
                            <CountTypographyMobile style={{ marginBottom: '-10px' }}>
                                {StandCount !== undefined || StandCount !== null || StandCount !== "" ? StandCount : '0'}
                            </CountTypographyMobile>
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <Box bgcolor="black" color='info.contrastText' borderRadius={2} p={1.5} onClick={(e) => { loginStore.setDialogOpen("MiningTransform") }}>
                        <Grid container xs={12} item sm={12} md={12} direction="row" >
                            <Grid container item spacing={4} xs={6} sm={6} md={6} justifyContent='flex-Start'>
                                <Grid container item xs={2} sm={1} md={2} alignItems='center' >
                                    <img style={{ width: '25px', height: "25px" }} src={MiningImage} alt="MiningImage" />
                                </Grid>
                                <Grid container item xs={2} sm={2} md={2} alignItems='flex-end'>
                                    <CountTypographyMobile  >
                                        {CoinStore?.DBData === undefined || null || "" ? "" : CoinStore?.DBData}
                                    </CountTypographyMobile>
                                </Grid>
                            </Grid>
                            <Grid container item xs={6} sm={6} md={6} justifyContent="flex-end" alignItems='center' >
                                <img style={{ width: '35px', height: '35px' }} src={EditImage} alt="EditImage" />
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <Box bgcolor="black" color="info.contrastText" borderRadius={2} p={1.3} onClick={(e) => { loginStore.setDialogOpen("Mining") }}>
                        <Grid container direction="column" marginTop="-5px">
                            <Grid container item xs={12} sm={12} md={4} direction="row" spacing={1} alignItems='center' marginTop='1px'>
                                <Grid container item xs={6} sm={5} md={6} justifyContent='space-between'   >
                                    <Grid container item xs={10} sm={10} md={10} direction="row" >
                                        <img style={{ width: '25px', height: '25px' }} src={MiningImage} alt="MiningImage" />
                                        <CountTypographyMobile style={{ marginLeft: "2%", marginTop: "2%" }}>
                                            {
                                                MiningUserMiningListData?.mined_stand !== undefined ?
                                                    MiningUserMiningListData?.mined_stand !== null ?
                                                        MiningUserMiningListData?.mined_stand !== 0 ?
                                                            MiningUserMiningListData?.mined_stand : ".0"
                                                        :
                                                        ".0"
                                                    :
                                                    ".0"
                                            }
                                        </CountTypographyMobile>
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2}>
                                        <img style={{ width: '25px' }} src={TimeImage} alt="TimeImage" />
                                    </Grid>
                                </Grid>
                                <Grid container item xs={4} sm={5} md={4} justifyContent='space-between' >
                                    <CountTypographyMobile variant={isMD ? "caption" : "subtitle1"} >
                                        {MiningStore?.RemainSecondSec !== undefined || null ?
                                            MiningStore?.RemainSecondHour !== 0 ?
                                                Number.isNaN(MiningStore?.RemainSecondHour) ?
                                                    "00.00"
                                                    :
                                                    MiningStore?.RemainSecondHour + "." + MiningStore?.RemainSecondMin + '.' + MiningStore?.RemainSecondSec
                                                :
                                                MiningStore?.RemainSecondMin + '.' + MiningStore?.RemainSecondSec : "00.00"}</CountTypographyMobile>
                                    <CountTypographyMobile variant={isMD ? "caption" : "subtitle1"} >{MiningUserMiningListData?.remain_count !== undefined ? MiningUserMiningListData?.remain_count : "0"}{Guide_clover_allPage_06}</CountTypographyMobile>
                                </Grid>
                                <Grid container item xs={2} sm={2} md={2} justifyContent='flex-end' >
                                    <img style={{ width: '25px' }} src={PulsImage} alt="PulsImage" />
                                </Grid>
                            </Grid>
                            <Box >
                                <LinearProgress variant="determinate" value={MiningStore?.TimeBarValue} />
                            </Box>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>

        </div>
    )
};


export default observer(MiningBar);